import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import BaseLayout from '../../components/layouts/base';
import { getAuthToken, setRedirectRoute } from '../../utils/auth';
import { CookieKeys } from '../../utils/constants';

export const PrivateRoute = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // // Clear sessionStorage on page reload only
    const handleBeforeUnload = () => {
      sessionStorage.setItem(CookieKeys.VISITED, 'true');
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  if (!getAuthToken()) {
    setRedirectRoute(pathname);
    return <Navigate to='/login' />;
  }

  // if (pathname === "/onboarding") {
  //   return <OnboardingLayout />;
  // }

  return <BaseLayout />;
};
